import { Component, OnInit, Input, ViewChild } from '@angular/core';
import { PermissionsModuleAccessLevel } from '@predictiveindex/client-permissions-lib';
import { ModuleName } from '../../core-data-model';
import { Util } from '../../core-utilities';
import { InitDataService } from '../../system-services';
import { TranslationService } from '../../translations';
import { ModuleUserManagementComponent } from './module-user-management-grid/module-user-management-grid.component';
import { ModuleUserManagementInvitationComponent } from './module-user-management-invitation/module-user-management-invitation.component';
import { ModuleUserManagementService } from './service/module-user-management.service';

@Component({
    selector: 'pi-module-user-management-tab',
    templateUrl: './module-user-management-tab.component.html',
    styleUrls: ['./module-user-management-tab.component.less'],
    providers: [ModuleUserManagementService],
    standalone: false
})
export class ModuleUserManagementTabComponent implements OnInit {
    @Input() moduleName: ModuleName;
    @ViewChild('piModuleInvitation')
    invitationInput: ModuleUserManagementInvitationComponent;
    @ViewChild('piModuleManageUsers')
    manageUsersGrid: ModuleUserManagementComponent;

    enableInvitationBlock = false;

    accessLevel: PermissionsModuleAccessLevel;

    constructor(
        public TR: TranslationService,
        public initDataService: InitDataService,
        public util: Util
    ) {}

    async ngOnInit() {
        this.accessLevel =
            (await this.initDataService.userAccessLevelMap.get(this.moduleName)
                ?.userAccessLevel) || PermissionsModuleAccessLevel.NoAccess;
        const hasModuleAdminAccess =
            this.accessLevel === PermissionsModuleAccessLevel.AllModuleAdmin ||
            this.accessLevel === PermissionsModuleAccessLevel.AllCompanyAdmin;

        this.enableInvitationBlock = hasModuleAdminAccess;
    }

    refreshGridData() {
        // refresh grid
        this.manageUsersGrid.refreshGridData();
    }

    getInvitationsDescriptionText(): string {
        return this.util.strings.formatString(
            this.TR.key('userManagement.sendInvitations-description'),
            this.moduleName
        );
    }
}
